import { IAutomationApiUrlType, IDistributionChannel, IModuleType, IWhatsAppTemplate } from '@store/companyStore/type'
import { StoreExt } from '@utils/reactExt'
import { observable, action, computed, runInAction } from 'mobx'
import {
    ICompany,
    ICompanyStatus,
    ICompanyType,
    IExternalCrmSystem,
    IModuleSettingTypes,
    IPaymentService,
    IPrintingHouse,
    IWaterMeterReaderSupplier,
    IWidgetType
} from './type'

export class MetaDataStore extends StoreExt {
    @observable
    companies: ICompany[] = []

    @observable
    moduleTypes: IModuleType[] = []
    @observable
    widgetTypes: IWidgetType[] = []

    @observable
    companyStatus: ICompanyStatus[] = []

    @observable
    moduleSettingTypes: IModuleSettingTypes[] = []

    @observable
    paymentServices: IPaymentService[] = []

    @observable
    printingHouses: IPrintingHouse[] = []

    @observable
    externalCrmSystems: IExternalCrmSystem[] = []

    @observable
    waterMeterReaderSuppliers: IWaterMeterReaderSupplier[] = []

    @computed
    get computedCompanyStatus() {
        return [{ id: 0, name: 'הכל' }, ...this.companyStatus]
    }

    @computed
    get computedCompanyTypes() {
        return [{ id: 0, name: 'הכל' }, ...this.companyType]
    }

    @computed
    get computedModuleStatus() {
        return [
            { id: 0, name: 'הכל' },
            { id: 1, name: 'פעיל' },
            { id: 2, name: 'מושהה' }
        ]
    }
    @observable
    companyTypeValue = 0

    @observable
    companyStatusValue = 0

    @observable
    companySearchValue = ''

    @observable
    moduleStatusValue = 0

    @observable
    moduleStatuses: ICompanyStatus[] = []

    @observable
    companyType: ICompanyType[] = []

    @observable
    distributionChannels: IDistributionChannel[] = []

    @observable
    whatsAppTemplates: IWhatsAppTemplate[] = []

    @computed
    get automationApiUrlTypes(): IAutomationApiUrlType[] {
        return [
            { type: 0, name: 'Login Api' },
            { type: 1, name: 'Get Assets Balances' },
            { type: 2, name: 'Create Voucher' },
            { type: 3, name: 'Get Services' },
            { type: 4, name: 'Get Itrot' }
        ]
    }

    @action
    setModuleStatus = (moduleStatus: number) => {
        this.moduleStatusValue = moduleStatus
    }

    @action
    getCompanies = async () => {
        const data = await this.api.metaData.getAllCompanies()
        runInAction(() => {
            this.companies = data
        })
    }

    @action
    getMetaData = async () => {
        const data = await this.api.metaData.getMetaData()
        runInAction(() => {
            this.companyStatus = data.statuses.map(item => {
                return { ...item, text: item.name, value: item.id }
            })
            this.companyType = data.types
            this.moduleTypes = data.moduleTypes
            this.moduleSettingTypes = data.moduleSettingTypes.filter(p => p.isActive)
            this.widgetTypes = data.widgetTypes
            this.paymentServices = data.paymentServices
            this.printingHouses = data.printingHouses
            this.whatsAppTemplates = data.whatsAppTemplates
            this.distributionChannels = data.distributionChannels
            this.waterMeterReaderSuppliers = data.waterMeterReaderSuppliers

            //Add default empty payment service
            this.externalCrmSystems = data.externalCrmSystems

            this.paymentServices.push({ id: null, name: 'ללא מערכת גביה' })
            this.printingHouses.push({ id: null, printingHouseName: '', printingHouseNameHebrew: 'ללא - ברירת מחדל' })
            this.externalCrmSystems.push({ id: null, name: 'ללא' })
            this.waterMeterReaderSuppliers.push({ id: null, supplierName: 'ללא' })
        })
    }
    @action
    setCompanyType = (companyTypeValue: number) => {
        this.companyTypeValue = companyTypeValue
    }
    @action
    setCompanyStatus = (companyStatusValue: number) => {
        this.companyStatusValue = companyStatusValue
    }
    @action
    setCompanySearch = (companySearchValue: string) => {
        this.companySearchValue = companySearchValue
    }

    @computed
    get filteredCompanies() {
        let filteredCompanies = this.companies

        if (this.companyTypeValue != 0) {
            filteredCompanies = filteredCompanies.filter(p => p.type === this.companyTypeValue)
        }
        if (this.companyStatusValue != 0) {
            filteredCompanies = filteredCompanies.filter(p => p.status === this.companyStatusValue)
        }
        if (this.companySearchValue) {
            filteredCompanies = filteredCompanies.filter(p => p.name.includes(this.companySearchValue))
        }
        return filteredCompanies
    }
    @computed
    get filteredModules() {
        let filteredModules = this.moduleTypes
        if (this.moduleStatusValue == 1) {
            filteredModules = filteredModules.filter(p => p.isActive)
        } else if (this.moduleStatusValue == 2) {
            filteredModules = filteredModules.filter(p => !p.isActive)
        }
        return filteredModules
    }
}

export default new MetaDataStore()
